module.exports = __webpack_public_path__ + "assets/images/swoosh.7b28c41b4b7fcb69b15c86df832860d3.svg";